export default {"src":"/_next/static/media/x-twitter-icon.27cf549f.svg","height":32,"width":32};